{
  "schemaVersion": 1,
  "families": [
    {
      "kind": "quantity",
      "familyId": "quantity-to-numeral",
      "title": "Conta",
      "icon": "🍎 3",
      "domainLabel": "Numeri · quantità",
      "skillId": "math.number-sense.quantity-to-numeral.1-5",
      "minAge": 5,
      "maxAge": 8,
      "variantFloor": 30,
      "difficulty": { "min": 1, "max": 5 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Matematica · Scuola primaria · OSA classe terza · Numeri · conteggio e aspetti cardinale/ordinale" }]
    },
    {
      "kind": "compare",
      "familyId": "compare-quantities",
      "title": "Di più",
      "icon": "🍎 ↔ ⭐",
      "domainLabel": "Numeri · confronta",
      "skillId": "math.number-sense.compare-quantities.1-5",
      "minAge": 5,
      "maxAge": 8,
      "variantFloor": 60,
      "difficulty": { "min": 1, "max": 5 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Matematica · Scuola primaria · OSA classe terza · Numeri · confrontare e ordinare numeri naturali" }]
    },
    {
      "kind": "sequence",
      "familyId": "simple-sequence",
      "title": "Continua",
      "icon": "🔵 🟡 🔵 ?",
      "domainLabel": "Logica · sequenze",
      "skillId": "math.patterns.simple-sequence",
      "minAge": 5,
      "maxAge": 8,
      "variantFloor": 24,
      "difficulty": { "min": 1, "max": 2 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Matematica · Scuola primaria · regolarità in sequenze di numeri o figure" }]
    },
    {
      "kind": "instruction",
      "familyId": "one-step-instruction",
      "title": "Ascolta",
      "icon": "🔊 🎯",
      "domainLabel": "Attenzione · ascolto",
      "skillId": "school.attention.one-step-instruction",
      "minAge": 5,
      "maxAge": 8,
      "variantFloor": 18,
      "difficulty": { "min": 1, "max": 1 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Scuola primaria · Informatica · sequenze di passi precisi e non ambigui e loro esecuzione" }]
    },
    {
      "kind": "number-next",
      "familyId": "number-successor-1-10",
      "title": "Dopo",
      "icon": "4 → ?",
      "domainLabel": "Numeri · ordine",
      "skillId": "math.number-sense.successor.1-10",
      "minAge": 6,
      "maxAge": 8,
      "variantFloor": 27,
      "difficulty": { "min": 1, "max": 10 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Matematica · Scuola primaria · OSA classe terza · Numeri · conteggio progressivo e numero naturale come ricorsivo" }]
    },
    {
      "kind": "number-previous",
      "familyId": "number-predecessor-1-10",
      "title": "Prima",
      "icon": "? ← 6",
      "domainLabel": "Numeri · ordine",
      "skillId": "math.number-sense.predecessor.1-10",
      "minAge": 6,
      "maxAge": 8,
      "variantFloor": 27,
      "difficulty": { "min": 1, "max": 10 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Matematica · Scuola primaria · OSA classe terza · Numeri · conteggio regressivo e numero naturale come ricorsivo" }]
    },
    {
      "kind": "number-greater",
      "familyId": "greater-numeral-1-10",
      "title": "Più grande",
      "icon": "7 ↔ 4",
      "domainLabel": "Numeri · confronta",
      "skillId": "math.number-sense.compare-numerals.1-10",
      "minAge": 6,
      "maxAge": 8,
      "variantFloor": 45,
      "difficulty": { "min": 1, "max": 10 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Matematica · Scuola primaria · OSA classe terza · Numeri · confrontare e ordinare numeri naturali" }]
    },
    {
      "kind": "number-between",
      "familyId": "number-between-1-10",
      "title": "In mezzo",
      "icon": "3 · ? · 5",
      "domainLabel": "Numeri · ordine",
      "skillId": "math.number-sense.between.1-10",
      "minAge": 6,
      "maxAge": 8,
      "variantFloor": 24,
      "difficulty": { "min": 1, "max": 10 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Matematica · Scuola primaria · OSA classe terza · Numeri · confrontare, ordinare e rappresentare numeri naturali sulla retta" }]
    },
    {
      "kind": "visual-addition",
      "familyId": "visual-addition-within-5",
      "title": "Aggiungi",
      "icon": "🍎 + 🍎",
      "domainLabel": "Calcolo · addizione",
      "skillId": "math.operations.visual-addition.within-5",
      "minAge": 6,
      "maxAge": 8,
      "variantFloor": 20,
      "difficulty": { "min": 0, "max": 5 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Matematica · Scuola primaria · OSA classe terza · Numeri · semplici addizioni con numeri naturali" }]
    },
    {
      "kind": "visual-subtraction",
      "familyId": "visual-subtraction-within-5",
      "title": "Togli",
      "icon": "⭐⭐⭐ − ⭐",
      "domainLabel": "Calcolo · sottrazione",
      "skillId": "math.operations.visual-subtraction.within-5",
      "minAge": 6,
      "maxAge": 8,
      "variantFloor": 20,
      "difficulty": { "min": 0, "max": 5 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Matematica · Scuola primaria · OSA classe terza · Numeri · semplici sottrazioni con numeri naturali" }]
    },
    {
      "kind": "shape-name",
      "familyId": "recognize-basic-shapes",
      "title": "Figure",
      "icon": "○ △ □",
      "domainLabel": "Geometria · figure",
      "skillId": "math.geometry.recognize-basic-shapes",
      "minAge": 5,
      "maxAge": 8,
      "variantFloor": 24,
      "difficulty": { "min": 1, "max": 4 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Matematica · Scuola primaria · OSA classe terza · Spazio e figure · riconoscere e denominare le principali figure geometriche" }]
    },
    {
      "kind": "shape-property",
      "familyId": "shape-by-sides",
      "title": "Lati",
      "icon": "△ = 3",
      "domainLabel": "Geometria · proprietà",
      "skillId": "math.geometry.shape-properties.sides",
      "minAge": 6,
      "maxAge": 8,
      "variantFloor": 18,
      "difficulty": { "min": 3, "max": 4 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Matematica · Scuola primaria · OSA classe terza · Spazio e figure · descrivere figure secondo caratteristiche, ad esempio numero di lati" }]
    },
    {
      "kind": "alphabet-next",
      "familyId": "italian-alphabet-next",
      "title": "Alfabeto",
      "icon": "A B ?",
      "domainLabel": "Italiano · alfabeto",
      "skillId": "italian.alphabet.order.next",
      "minAge": 6,
      "maxAge": 8,
      "variantFloor": 21,
      "difficulty": { "min": 1, "max": 21 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Italiano · Scuola primaria · OSA classe terza · Alfabeto · enunciare nell'ordine convenzionale le lettere" }]
    },
    {
      "kind": "vowel-recognition",
      "familyId": "italian-recognize-vowels",
      "title": "Vocali",
      "icon": "A E I",
      "domainLabel": "Italiano · lettere",
      "skillId": "italian.alphabet.recognize-vowels",
      "minAge": 6,
      "maxAge": 8,
      "variantFloor": 35,
      "difficulty": { "min": 1, "max": 5 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Italiano · Scuola primaria · OSA classe terza · Alfabeto e alfabetizzazione di base" }]
    },
    {
      "kind": "initial-letter",
      "familyId": "italian-word-initial-letter",
      "title": "Inizia con",
      "icon": "M → 🍎?",
      "domainLabel": "Italiano · fonema-grafema",
      "skillId": "italian.phonics.initial-letter",
      "minAge": 6,
      "maxAge": 8,
      "variantFloor": 48,
      "difficulty": { "min": 1, "max": 8 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Italiano · Scuola primaria · OSA classe terza · Grafia dell'italiano · conoscere fonemi e grafemi" }]
    },
    {
      "kind": "syllable-count",
      "familyId": "italian-syllable-count",
      "title": "Sillabe",
      "icon": "CA-SA = 2",
      "domainLabel": "Italiano · sillabe",
      "skillId": "italian.phonics.syllable-count",
      "minAge": 6,
      "maxAge": 8,
      "variantFloor": 36,
      "difficulty": { "min": 1, "max": 4 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Italiano · Scuola primaria · OSA classe terza · Grafia dell'italiano · utilizzare la divisione in sillabe" }]
    },
    {
      "kind": "punctuation-mark",
      "familyId": "italian-punctuation-basic",
      "title": "Segni",
      "icon": ". ? !",
      "domainLabel": "Italiano · punteggiatura",
      "skillId": "italian.writing.punctuation.basic",
      "minAge": 7,
      "maxAge": 8,
      "variantFloor": 30,
      "difficulty": { "min": 1, "max": 3 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Italiano · Scuola primaria · OSA classe terza · Interpunzione · punto, punto interrogativo e punto esclamativo" }]
    },
    {
      "kind": "listen-two-step",
      "familyId": "italian-listen-two-step",
      "title": "Due passi",
      "icon": "👂 1→2",
      "domainLabel": "Italiano · ascolto",
      "skillId": "italian.listening.two-step-instruction",
      "minAge": 6,
      "maxAge": 8,
      "variantFloor": 36,
      "difficulty": { "min": 2, "max": 2 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Italiano · Scuola primaria · OSA classe terza · Ascolto e dialogo · comprendere semplici istruzioni" }]
    },
    {
      "kind": "text-character",
      "familyId": "italian-short-text-character",
      "title": "Chi?",
      "icon": "📖 👤",
      "domainLabel": "Italiano · comprensione",
      "skillId": "italian.reading.identify-character",
      "minAge": 7,
      "maxAge": 8,
      "variantFloor": 30,
      "difficulty": { "min": 1, "max": 3 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Italiano · Scuola primaria · OSA classe terza · Lettura e interpretazione · individuare elementi essenziali, personaggi luoghi tempi" }]
    },
    {
      "kind": "text-place",
      "familyId": "italian-short-text-place",
      "title": "Dove?",
      "icon": "📖 📍",
      "domainLabel": "Italiano · comprensione",
      "skillId": "italian.reading.identify-place",
      "minAge": 7,
      "maxAge": 8,
      "variantFloor": 30,
      "difficulty": { "min": 1, "max": 3 },
      "sourceMappings": [{ "sourceId": "it-mim-dm-221-2025", "locator": "Allegato · Italiano · Scuola primaria · OSA classe terza · Lettura e interpretazione · individuare elementi essenziali, personaggi luoghi tempi" }]
    }
  ]
}
